import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import {Action, Help} from '../../../system/buttons';
import Ranges from '../../../system/ranges';
import {FilePickerModal, FileTypeVideo} from '../../../system/gallery';

export class VideoEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
      showFilePicker: true,
    };
  }

  saveConfiguration = () => {
    this.props.onSave({
      ranges: this.state.ranges,
      gallery: this.state.gallery,
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        ranges: this.state.ranges,
        gallery: this.state.gallery,
      });
    }
  }

  render() {
    return (
      <>
        <h4>Configured ranges</h4>
        <Ranges
          ranges={this.state.ranges}
          onRangesChange={(ranges) => this.setState({ranges})}
          defaultRange={{
            from: 60,
            to: 90,
          }}
          header={
            <Col md={4}>
              <Form inline>
                <Col>Video</Col>
              </Form>
            </Col>
          }
          rangeConfiguration={(range, onRangeChange) => (
            <FileForm
              onRangeChange={onRangeChange}
              range={range}
              gallery={this.state.gallery}
            />
          )}
        />
        <div>&nbsp;</div>
        <Action onClick={this.saveConfiguration}>Save settings</Action>
      </>
    );
  }
}

class FileForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showFilePicker: false,
    };
  }

  render() {
    return (
      <Col md={4} key={this.props.range.from}>
        {this.state.showFilePicker && (
          <FilePickerModal
            fileType={FileTypeVideo}
            show={this.state.showFilePicker}
            hide={() => this.setState({showFilePicker: false})}
            onChoose={(file) =>
              this.setState({showFilePicker: false}, () =>
                this.props.onRangeChange({
                  ...this.props.range,
                  file,
                })
              )
            }
          />
        )}
        <Help onClick={() => this.setState({showFilePicker: true})}>
          {this.props.range.file ? this.props.range.file.name : 'Select file'}
        </Help>
      </Col>
    );
  }
}
